<div
  id="dashboard-modal"
  class="modal fade-scale in"
  role="dialog"
  style="background-color: rgba(0, 0, 0, 0); display: block"
>
  <div class="modal-dialog" style="display: table; width: auto">
    <div class="modal-content error-modal-content">
      <div class="modal-body">
        <h4 id="heading-modal" class="head-modal">No action selected</h4>
        <hr class="modal-hr-line" />
        <p id="err-recurly-modal-body" class="inbody-modal">
          Please check one or more boxes.
        </p>
        <div class="btn-container" style="text-align: right">
          <button
            type="button"
            class="btn accept-btn gernal-btn"
            data-dismiss="modal"
            style="float: right; border-radius: 0px; margin-top: 10px"
            (click)="noActionDIalog()"
          >
            OK
          </button>
        </div>
        <br />
        <br />
        <br />
      </div>
    </div>
  </div>
</div>
